import { trackingService } from '@monthio/react-components'
import { beforeUnloadSubject } from '../../utils/beforeUnloadSubject'
import { StorageService } from './StorageService'
import { combineLatest } from 'rxjs'
import { tabManagerService } from '../tabManagerService'

class UserLeftService {
	#storage: StorageService | null = null
	#applicantId: string | null = null
	#applicantSessionId: string | null = null
	#userContinuedKey: string | null = null

	public readonly initialize = () => {
		this.#storage = new StorageService()
		// Maybe it works with the filter as multiple tabs should not be able to be active
		const subscription = combineLatest([
			beforeUnloadSubject,
			tabManagerService.tabStatus,
		]).subscribe(([, tabStatus]) => {
			// if the tab is active but not last tab, then user is continuing

			if (tabStatus === 'active') {
				this.#userLeft()
				return
			}
			tabManagerService.closeTab()
			subscription.unsubscribe()
		})
	}

	#userLeft = () => {
		const key = this.#getStorageKey
		if (key == null) {
			return
		}
		this.#sendEvent('Left')
		this.#storage!.set(key, new Date().getTime())
	}

	public readonly setApplicantData = (
		applicantId: string | null,
		applicantSessionId: string | null,
	) => {
		const key = this.#getStorageKey

		this.#applicantId = applicantId ?? null
		this.#applicantSessionId = applicantSessionId ?? null
		if (this.#applicantId == null || this.#applicantSessionId == null) {
			return
		}
		const updatedKey = this.#getStorageKey!
		const hasLeft = this.#storage!.get<number>(updatedKey) != null
		if (!hasLeft && key !== updatedKey) {
			this.#sendEvent('Entered')
			return
		}

		if (hasLeft && this.#userContinuedKey !== updatedKey) {
			this.#userContinuedKey = updatedKey
			this.#sendEvent('Continued')
		}
	}

	#sendEvent = (eventType: 'Entered' | 'Left' | 'Continued') => {
		trackingService.trackEvent(`User ${eventType}`, {
			applicantId: this.#applicantId,
			applicantSessionId: this.#applicantSessionId,
		})
		// call budget app with userEvent
	}

	get #getStorageKey() {
		if (this.#applicantId == null || this.#applicantSessionId == null) {
			return
		}
		return `user-left::${this.#applicantId}:${this.#applicantSessionId}`
	}
}

export { UserLeftService as UserLeftServiceTest }

export const userLeftService = new UserLeftService()
